import React from "react";
import { X } from "lucide-react";
import "@/styles/index.css";

type ClearButtonProps = {
  onClick?: () => void;
  title?: string;
  ariaLabel?: string;
  className?: string;
};

export const ClearButton: React.FC<ClearButtonProps> = ({
  onClick,
  title = "Clear",
  ariaLabel = "Clear value",
  className = ""
}) => {
  const triggerClear = () => {
    if (onClick) onClick();
  };

  const handleClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
    triggerClear();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      event.stopPropagation();
      triggerClear();
    }
  };

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`clear-button ${className}`.trim()}
      aria-label={ariaLabel}
      title={title}
    >
      <X className="icon" />
    </span>
  );
};
